<template>
    <section class="assessmentSection questionsSection">
        <div class="pageContent">

            <section class="trueAdviceCard resolveCard"
                     v-if="system.advice.environmental">
                <div class="trueAdviceCard-header">
                    <img src="/img/alert.png"
                         alt="Open Window"> Fire Protection
                </div>
                <div class="trueAdviceCard-advice">
                    Consider adding {{ recommendedTotal }} smoke communicators
                </div>
                <div class="trueAdviceCard-detail">
                    <!-- You have no smoke communicators. -->
                    Smoke communicators are reliable and dependable. They call the fire department when you can’t.
                </div>
                <!-- Status Row -->
                <div class="trueAdviceCard-statusRow">
                    <div class="trueAdviceCard-statusRow-iconCount" :class="{'resolved': resolvedFloors}">
                        <img src="/img/yield.png"
                             alt="Yield"
                             v-if="!resolvedFloors" />
                        <img src="/img/shield-checkmark.png"
                             alt="Checkmark Shield"
                             v-if="resolvedFloors" />
                        <div class="count">
                            {{ addedFloors }}/{{ recommendedFloors }}
                        </div>

                    </div>
                    <div class="trueAdviceCard-statusRow-text">
                        A smoke communicator should be installed 1 on each floor, with 1 outside the sleeping area to protect you from fire while you sleep.
                        <div>
                            <router-link to="#">
                                Why do I need one on each floor?
                            </router-link>
                        </div>
                    </div>
                </div>
                <!-- End Status Row -->
                <!-- Status Row -->
                <div class="trueAdviceCard-statusRow"
                     v-if="recommendedBasement > 0">
                    <div class="trueAdviceCard-statusRow-iconCount" :class="{'resolved': resolvedBasement}">
                        <img src="/img/yield.png"
                             alt="Yield"
                             v-if="!resolvedBasement" />
                        <img src="/img/shield-checkmark.png"
                             alt="Checkmark Shield"
                             v-if="resolvedBasement" />
                        <div class="count">
                            {{ addedBasement }}/{{ recommendedBasement }}
                        </div>

                    </div>
                    <div class="trueAdviceCard-statusRow-text">

                        <div v-if="lead.homeBasementFinished === 'Finished'">
                            Finished basements present unique fire risks because there is often a door blocking the utility room off from the rest of the usable basement. A smoke communicator should be placed inside the utility room, and outside the utility room.
                            <div>
                                <router-link to="#">
                                    Why inside and outside the furnace room?
                                </router-link>
                            </div>
                        </div>

                        <div v-if="lead.homeBasementFinished === 'Unfinished'">
                            Unfinished basements often have a utility/furnace room that can malfucntion or cause a fire. 1 Smoke communicator should be installed in the basement if the furnace/utility room is not closed off from the rest of the basement.
                            <div>
                                <router-link to="#">
                                    My furnace is closed off
                                </router-link>
                            </div>
                        </div>

                    </div>
                </div>
                <!-- End Status Row -->
            </section>

            <section class="resolveSection">
                <div class="resolveTitle">
                    <hr>
                    <span>Resolve the issue</span>
                </div>

                <div class="resolveMessage">
                    You have <span>{{ equipmentCount }}/{{ recommendedTotal }}</span> recommended Smoke communicators
                </div>
                <div class="resolveSolution">
                    Add {{ recommendedTotal }} smoke communicators to resolve this issue.
                </div>

                <AutomationQuantityAdjuster name="Smoke communicator"
                                              plural="Smoke communicators"
                                              theKey="Fire"
                                              :equipment="equipmentByName('Smoke Communicator')" />

            </section>

            <continue-button v-if="resolved"
                             :before="addFireProtection"
                             text="Resolve"
                             to="/assessment/system" />


        </div>
    </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import AutomationQuantityAdjuster from '../components/InterestedEquipmentAdjuster.vue'
export default {
    components: {
        AutomationQuantityAdjuster
    },
    computed: {
        ...mapState(['system', 'equipment', 'lead']),

        ...mapGetters(['equipmentByName']),

        equipmentCount() {
            return this.lead.automationQuantities.Fire
        },

        environmentalAdvice() {
            return this.system.advice.environmental
        },

        recommendedTotal() {
            return this.environmentalAdvice.length
        },

        addedFloors() {
            let added = this.equipmentCount

            if (added > this.recommendedFloors) {
                return added - this.addedBasement
            }

            return added
        },

        addedBasement() {
            let added = this.equipmentCount
            let floorsProtected = added >= this.recommendedFloors

            if (floorsProtected) {
                let extra = added - this.recommendedFloors

                // If more than recommended for basement, only add basement
                if (extra >= this.recommendedBasement) {
                    return this.recommendedBasement
                }

                if (extra < this.recommendedBasement) {
                    return extra
                }
            }

            return 0
        },

        recommendedFloors() {
            return this.environmentalAdvice.filter(
                advice => advice.location !== 'Basement'
            ).length
        },

        recommendedBasement() {
            return this.environmentalAdvice.filter(
                advice => advice.location === 'Basement'
            ).length
        },

        resolved() {
            return this.equipmentCount >= this.recommendedTotal
        },

        resolvedFloors() {
            return this.addedFloors >= this.recommendedFloors
        },

        resolvedBasement() {
            return this.addedBasement >= this.recommendedBasement
        }
    },
    methods: {
        ...mapActions([
            'updateSystem',
            'resolveAdvice',
            'setInterestedEquipmentQty',
            'addFireProtection'
        ])
    },
    mounted() {
        this.updateSystem()
        mixpanel.track("viewedTrueAdvice", {
            advice: 'Fire'
        })
    }
}
</script>

<style lang="css"></style>
